import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "goods" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageContent, {
      ref: "pageContentRef",
      contentConfig: _ctx.contentConfig,
      pageName: "goods"
    }, {
      image: _withCtx((slot) => [
        _createVNode(_component_el_image, {
          src: slot.row.imgUrl,
          "preview-src-list": [slot.row.imgUrl],
          style: {"width":"80px","height":"80px"}
        }, null, 8, ["src", "preview-src-list"])
      ]),
      oldPrice: _withCtx((slot) => [
        _createTextVNode(_toDisplayString('￥' + slot.row.oldPrice), 1)
      ]),
      _: 1
    }, 8, ["contentConfig"])
  ]))
}